import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolderView = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M9 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9 3h6v12H1V0h6zm-3.008 8.243L4 9.5v-1l1.992-1.743a3.05 3.05 0 0 1 4.016 0L12 8.5v1l-1.992 1.743a3.05 3.05 0 0 1-4.016 0",
		clipRule: "evenodd"
	})]
});
export default SvgFolderView;
